import { Scroller } from 'src/components/Scroller/Scroller'
import { TestimonialItem } from 'src/components/TestimonialItem/TestimonialItem'
import { testimonials } from 'src/config/testimonials'
import { FormattedText } from 'src/core/ds/FormattedText'
import styles from '../index.module.scss'

export function Testimonials() {
  return (
    <div className={styles.testimonial}>
      <h2>
        <FormattedText id="landing.testimonials.title" />
      </h2>
      <p>
        <FormattedText id="landing.testimonials.description" />
      </p>
      <Scroller direction="right" speed="slow">
        {testimonials.map((item) => (
          <TestimonialItem key={item.id} data={item} />
        ))}
      </Scroller>
    </div>
  )
}
